/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_AssigneeInputs */

const en_task_field_assignee = /** @type {(inputs: Task_Field_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignee`)
};

const pt_br2_task_field_assignee = /** @type {(inputs: Task_Field_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsável`)
};

/**
* | output |
* | --- |
* | "Assignee" |
*
* @param {Task_Field_AssigneeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_assignee = /** @type {((inputs?: Task_Field_AssigneeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_AssigneeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_assignee(inputs)
	return pt_br2_task_field_assignee(inputs)
});